module.exports = {
          srcSet: __webpack_public_path__ + "public/images/308a75dfc12d012fc17370c25debf8dc-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/308a75dfc12d012fc17370c25debf8dc-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/308a75dfc12d012fc17370c25debf8dc-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/308a75dfc12d012fc17370c25debf8dc-1774.jpg"},
          
          width: 1774,
          height: 887
        }